export const TipoCartera = ({ name, value, onChange }) => {
    return (
        <select name={name} value={value} onChange={onChange}>
            <option value='A'>Actual</option>
            <option value='C'>Cierre</option>
        </select>
    )
}